import { Box, ButtonBase, Typography } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import {
	couponBannerSX,
	couponCodeButtonSX,
	couponCodeSX,
	couponCopyIconSX,
	couponEyebrowSX,
	couponExpiryIconSX,
	couponExpirySX,
	couponLabelGroupSX,
	couponLabelSX,
	couponTopRowSX,
} from '@/components/blocks/EmailRecommendedCouponPopup/styles';

interface CouponBannerProps {
	code: string;
	label: string;
	expiry: string;
}

export const CouponBanner = ({ code, label, expiry }: CouponBannerProps) => {
	const handleOnCopy = () => {
		navigator.clipboard.writeText(code);
	};

	return (
		<Box sx={couponBannerSX}>
			<Box sx={couponTopRowSX}>
				<Box sx={couponLabelGroupSX}>
					<Typography sx={couponEyebrowSX}>{'Tu cupón personal'}</Typography>
					<Typography component="h3" sx={couponLabelSX}>
						{label}
					</Typography>
				</Box>
				<ButtonBase sx={couponCodeButtonSX} onClick={handleOnCopy} aria-label="Copiar cupón">
					<Typography sx={couponCodeSX}>{code}</Typography>
					<ContentCopyIcon sx={couponCopyIconSX} />
				</ButtonBase>
			</Box>
			<Box sx={couponExpirySX}>
				<AccessTimeIcon sx={couponExpiryIconSX} />
				<Typography component="span" sx={{ fontSize: 'inherit', fontWeight: 'inherit' }}>
					{expiry}
				</Typography>
			</Box>
		</Box>
	);
};
